import { cloneNested } from '@/helpers/helpers'

const attachmentModel = {}

export default {
  attachment: cloneNested(attachmentModel),
  attachmentModel: cloneNested(attachmentModel),
  attachments: [],
}
